(function (ws) {
    'use strict';
    ws.views.googleAnalytics = Backbone.View.extend({

        REMOVE_FROM_CART: 'removeFromCart',

        TYPE_REMOVE_CHANGE_QUANTITY: 'change_quantity',
        TYPE_REMOVE_REMOVE_PRODUCT: 'remove_product',
        TYPE_REMOVE_CLEAR_CART: 'clear_cart',
        TYPE_ADD_PRODUCT_PAGE: 'product_page',
        TYPE_ADD_CHANGE_QUANTITY: 'change_quantity',
        GTM_EVENT_NAME: 'gtm_event',
        GTM_QUOTING_SITE: 'quote',
        GTM_STORE_SITE: 'store',
        GTM_ORDERENTRY_SITE: 'order_entry',
        GTM_EVENT_CREATE_ORDER_WITH_PO: 'po_data_acquisition',
        GTM_EVENT_CREATE_ORDER_WITH_REFERENCE: 'create_with_reference',
        GTM_EVENT_CREATE_ORDER_WITH_EDI: 'edi',
        GTM_EVENT_CREATE_ORDER_FROM_QUOTE: 'convert_from_quote',
        GTM_EVENT_CREATE_ORDER_MANUAL: 'start_a_manual_order',
        GTM_EVENT_TRACKING_CREATE_ORDER: 'create_order',
        GTM_EVENT_CREATE_ORDER_VQREF: 'vendor_reference_order',
        GTM_EVENT_CREATE_ORDER_VQFILE: 'vendor_file_order',
        RULE_ENGINE_FIRST_TIME: 'first_time',
        GTM_NEW_QUOTE_EVENT_LABEL_UPLOAD: 'upload',
        GTM_NEW_QUOTE_EVENT_LABEL_API: 'api',
        GTM_NEW_QUOTE_EVENT_LABEL_MANUAL: 'manual',
        GTM_NEW_QUOTE_EVENT_LABEL_RENEWAL: 'renewal',
        GTM_NEW_QUOTE_EVENT_LABEL_STORAGE: 'gtm_new_order_label',
        eventDataLayer: {},

        /**
         * initialize the view
         */
        initialize: function() {
            this.dataLayer = dataLayer || [];
        },

        /**
         * log event to tag manager
         */
        logGTMEvent: function() {
            this.dataLayer = dataLayer || [];
            this.dataLayer.push(this.eventDataLayer);
        },

        /**
         * build event object
         */
        buildGTMEventObject: function(eventCategory, eventAction, eventLabel) {
            this.eventDataLayer = {};
            this.eventDataLayer.event = this.GTM_EVENT_NAME;
            this.eventDataLayer.eventCategory = eventCategory;
            this.eventDataLayer.eventAction = eventAction;

            if (eventLabel) {
                this.eventDataLayer.eventLabel = eventLabel;
            }
        },

        /**
         * builds event object and logs into tag manager
         */
        gtmEventTracking: function(eventCategory, eventAction, eventLabel) {
            this.buildGTMEventObject(eventCategory, eventAction, eventLabel);
            this.logGTMEvent();
        },

        /**
         * builds event object for order Submit and logs into tag manager
         */
        gtmOrderSubmit: function(eventCategory, eventAction, salesOrg, salesGroup, vendor, billingBlock, deliveryBlock) {
            this.eventDataLayer = {};
            this.eventDataLayer.event = this.GTM_EVENT_NAME;
            this.eventDataLayer.eventCategory = eventCategory;
            this.eventDataLayer.eventAction = eventAction;
            this.eventDataLayer.salesOrg = salesOrg;
            this.eventDataLayer.salesGroup = salesGroup;
            this.eventDataLayer.vendor = vendor;
            this.eventDataLayer.billingBlock = billingBlock;
            this.eventDataLayer.deliveryBlock = deliveryBlock;
            this.logGTMEvent();
        },

        /**
         * builds event object for Rule engines and logs into tag manager
         */
        gtmRuleEngine: function(eventCategory, eventAction, eventLabel, voe, salesOrg, caseReference,
                                accountNumber, accountName, dateOrder, SAPOrderNumber, rulesFields, customerReference) {
            this.eventDataLayer = {};
            this.eventDataLayer.event = this.GTM_EVENT_NAME;
            this.eventDataLayer.eventCategory = eventCategory;
            this.eventDataLayer.eventAction = eventAction;
            this.eventDataLayer.label = eventLabel;
            this.eventDataLayer.voe = voe;
            this.eventDataLayer.salesOrg = salesOrg;
            this.eventDataLayer.caseReference = caseReference;
            this.eventDataLayer.accountNumber = accountNumber;
            this.eventDataLayer.accountName = accountName;
            this.eventDataLayer.dateOrder = dateOrder;
            this.eventDataLayer.SAPOrderNumber = SAPOrderNumber;
            this.eventDataLayer.rulesFields = rulesFields;
            this.eventDataLayer.customerReference = customerReference;
            this.logGTMEvent();
        },

        /**
         * builds event object for Initiate new order details.
         */
        gtmCreateOrder: function(eventCategory, eventAction, eventLabel, voe, salesOrg, caseReference,
                                accountNumber, accountName, orderType, dateOrder, SAPOrderNumber, customerReference) {
            this.eventDataLayer = {};
            this.eventDataLayer.event = this.GTM_EVENT_NAME;
            this.eventDataLayer.eventCategory = eventCategory;
            this.eventDataLayer.eventAction = eventAction;
            this.eventDataLayer.label = eventLabel;
            this.eventDataLayer.voe = voe;
            this.eventDataLayer.salesOrg = salesOrg;
            this.eventDataLayer.caseReference = caseReference;
            this.eventDataLayer.accountNumber = accountNumber;
            this.eventDataLayer.accountName = accountName;
            this.eventDataLayer.orderType = orderType;
            this.eventDataLayer.dateOrder = dateOrder;
            this.eventDataLayer.SAPOrderNumber = SAPOrderNumber;
            this.eventDataLayer.customerReference = customerReference;
            this.logGTMEvent();
        },

        /**
         * builds event object for order details and logs into tag manager
         */
        gtmOrderDetails: function(eventCategory, eventAction, salesOrg, salesGroup, vendor) {
            this.eventDataLayer = {};
            this.eventDataLayer.event = this.GTM_EVENT_NAME;
            this.eventDataLayer.eventCategory = eventCategory;
            this.eventDataLayer.eventAction = eventAction;
            this.eventDataLayer.salesOrg = salesOrg;
            this.eventDataLayer.salesGroup = salesGroup;
            this.eventDataLayer.vendor = vendor;
            this.logGTMEvent();
        },

        /**
         * builds event object for order details when the user submit to sap
         * and "Perform PO match" runs
         */
        gtmPODataAcquisition: function(eventAction, poMatchingOnDemand, poDataAcquisitionData) {
            const eventLabel = poMatchingOnDemand ? 'manual' : 'automatic';
            this.eventDataLayer = {};
            this.eventDataLayer.event = this.GTM_EVENT_NAME;
            this.eventDataLayer.eventCategory = this.GTM_ORDERENTRY_SITE;
            this.eventDataLayer.eventAction = eventAction;
            this.eventDataLayer.eventLabel = eventLabel;
            this.eventDataLayer.voe = poDataAcquisitionData.voe;
            this.eventDataLayer.customerReference = poDataAcquisitionData.customerReference;
            this.eventDataLayer.caseReference = poDataAcquisitionData.caseReference;
            this.eventDataLayer.accountNumber = poDataAcquisitionData.accountNumber;
            this.eventDataLayer.accountName = poDataAcquisitionData.accountName;
            this.eventDataLayer.salesOrg = poDataAcquisitionData.salesOrg;
            this.eventDataLayer.submitMismatches = poDataAcquisitionData.submitMismatches;
            this.eventDataLayer.orderType = poDataAcquisitionData.orderType;
            this.eventDataLayer.dateOrder = poDataAcquisitionData.dateOrder;
            this.eventDataLayer.SAPOrderNumber = poDataAcquisitionData.SAPOrderNumber;
            this.eventDataLayer.mismatchedFields = poDataAcquisitionData.mismatchedFields;
            this.logGTMEvent();
        },

        /**
         * builds event object for order details when the user submit to sap
         * and check checkbox PO match overlay
         */
        gtmSubmitPOMismatches: function(eventAction, poMismatchesDataEvent) {
            this.eventDataLayer = {};
            this.eventDataLayer.event = this.GTM_EVENT_NAME;
            this.eventDataLayer.eventCategory = this.GTM_ORDERENTRY_SITE;
            this.eventDataLayer.eventAction = eventAction;
            this.eventDataLayer.eventLabel = 'submit';
            this.eventDataLayer.voe = poMismatchesDataEvent.voe;
            this.eventDataLayer.customerReference = poMismatchesDataEvent.customerReference;
            this.eventDataLayer.caseReference = poMismatchesDataEvent.caseReference;
            this.eventDataLayer.accountNumber = poMismatchesDataEvent.accountNumber;
            this.eventDataLayer.accountName = poMismatchesDataEvent.accountName;
            this.eventDataLayer.salesOrg = poMismatchesDataEvent.salesOrg;
            this.eventDataLayer.orderType = poMismatchesDataEvent.orderType;
            this.eventDataLayer.dateOrder = poMismatchesDataEvent.dateOrder;
            this.logGTMEvent();
        },

        /**
         * executes google analytics method to track the product removal
         * @param {string} type
         * @param {string} productName
         * @param {integer} idProduct
         * @param {integer} quantity
         * @param {string} price
         * @param {string} gaTrackingId
         * @param {string} brand
         * @param {Array} categories
         */
        gtmRemoveFromCart: function(type, productName, idProduct, quantity, price, gaTrackingId, brand, categories) {
            this.dataLayer.push({
                gatId: gaTrackingId,
                event: 'removeFromCart',
                type: type,
                ecommerce: {
                    remove: {
                        products: [{
                            name: productName,
                            id: idProduct,
                            price: price,
                            brand: brand,
                            category: categories,
                            quantity: quantity
                        }]
                    }
                }
            });
        },

        /**
         * executes google analytics method to clear cart
         * @param {string} type
         * @param {string} gaTrackingId
         * @param {Array} products
         */
        gtmClearCart: function(type, gaTrackingId, products) {
            this.dataLayer.push({
                gatId: gaTrackingId,
                event: 'removeFromCart',
                type: type,
                ecommerce: {
                    remove: {
                        products: this.generateArrayProducts(products)
                    }
                }
            });
        },

        /**
         * Creates products array to use on analytics
         * @param {Array} products
         * return array
         */
        generateArrayProducts: function(products) {
            var productsArray = [];
            _.each(products, function (item) {
                productsArray.push({
                    name: this.$(item).data('name'),
                    id: this.$(item).data('id'),
                    price: this.$(item).data('price'),
                    brand: this.$(item).data('brand'),
                    category: this.$(item).data('category'),
                    quantity: this.$(item).data('quantity')
                });
            }.bind(this));

            return productsArray;
        },

        /**
         * executes google analytics method to track the product add
         * @param {string} type
         * @param {string} productName
         * @param {integer} idProduct
         * @param {integer} quantity
         * @param {integer} price
         * @param {string} brand
         * @param {Array} categories
         * @param {string} currencyIso
         * @param {string} gaTrackingId
         */
        gtmAddToCart: function(type, productName, idProduct, quantity, price, brand, categories, currencyIso, gaTrackingId) {
            this.dataLayer.push({
                gatId: gaTrackingId,
                event: 'addToCart',
                type: type,
                ecommerce: {
                    currencyCode: currencyIso,
                    add: {
                        products: [{
                            name: productName,
                            id: idProduct,
                            price: price,
                            brand: brand,
                            category: categories,
                            quantity: quantity
                        }]
                    }
                }
            });
        },

        /**
         * executes google analytics method to track the product add
         * @param {string} eventAction
         * @param {string} currencyIso
         * @param {Array} products
         */
        gtmAddMultipleToCart: function(eventAction, currencyIso, products) {
            this.eventDataLayer = {
                event: 'addToCart',
                eventAction: eventAction,
                ecommerce: {
                    currencyCode: currencyIso,
                    add: {
                        products: products.map((item) => {
                            return {
                                name: item.description,
                                id: item.partNo,
                                price: item.resellerPrice,
                                brand: item.vendor,
                                category: item.itemCategorySelected,
                                quantity: item.quantity
                            };
                        })
                    }
                }
            };

            this.logGTMEvent();
        },

        /**
         * Creates products array to use on analytics
         * @param {Array} products
         * return array
         */
        generateArrayProductsForMultipleLines: function(products) {
            return products.map(function (rowId) {
                return {
                    name: this.$quoteCartTable.getCell(rowId, 2, true).innerText,
                    id: this.$quoteCartTable.getCell(rowId, 1, true).innerText,
                    price: this.$quoteCartTable.getCell(rowId, 15, true).innerText,
                    brand: this.$quoteCartTable.getCell(rowId, 0, true).innerText,
                    category: this.$quoteCartTable.getCell(rowId, 19, true).innerText,
                    quantity: this.$quoteCartTable.getCell(rowId, 3, true).innerText
                };
            }.bind(this));
        },

        /**
         * Remove products from cart
         */
        gtmRemoveProductsFromCart: function(products, currencyCode) {
            this.eventDataLayer = {
                event: 'removeFromCart',
                ecommerce: {
                    currencyCode: currencyCode,
                    remove: {
                        products: products.map((item) => {
                            if (item) {
                                return {
                                    name: item.get('description'),
                                    id: item.get('partNo'),
                                    price: item.get('resellerPrice'),
                                    brand: item.get('vendor'),
                                    category: item.get('itemCategorySelected'),
                                    quantity: item.get('quantity')
                                };
                            }
                        })
                    }
                }
            };
            this.logGTMEvent();
        },

        /**
         * New quote event
         */
        gtmNewQuoteEvent: function(eventLabel, quoteNumber) {
            this.eventDataLayer = {
                event: 'gtm_event',
                eventCategory: 'quote_request',
                eventAction: 'new_quote',
                eventLabel,
                quoteNumber
            };
            this.logGTMEvent();
        }
    });

})(westcon);
